module.exports = __webpack_public_path__ + "img/gnxcl_s.39ba0b3.png";